<template>
  <div>
    <div class="detail-head-211130">
      <h3 class="payment-tab-title">
        <span :class="selectTab === 'tab1' ? 'on' : ''" @click="checkTab('tab1')">订单信息</span>
        |
        <span :class="selectTab === 'tab2' ? 'on' : ''" @click="checkTab('tab2')"
        >查看关联订单</span
        >
      </h3>
      <div class="tip">
        收付款编号: {{ row.paymentsNum }}
        <span v-if="isHavePermission('twoPayments:createTimeRec')"
        >| 创建人: {{ row.createUser }} | 创建日期: {{ row.createTime }}</span
        >
      </div>
    </div>
    <div class="clearfix" v-show="selectTab === 'tab1'">
      <div class="add-box clearfix">
        <!-- :span-method="spanMethod" -->
        <vxe-table
            border
            show-overflow
            keep-source
            ref="t1"
            align="center"
            auto-resize
            highlight-hover-row
            class="table_insert"
            :edit-rules="editRules"
            :data="ordersList"
            :edit-config="{ trigger: 'click', mode: 'cell', showIcon: false }"
            @cell-click="cellClick"
        >
          <vxe-table-column field="ordersNum" title="订单编号">
            <template v-slot="{ row }">
              <div class="link-text">
                {{ row.ordersNum }}
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="buyerName" title="托运人名称"></vxe-table-column>
          <vxe-table-column field="compName" title="平台企业"></vxe-table-column>
          <vxe-table-column field="sellerName" title="承运人名称"></vxe-table-column>

          <vxe-table-column field="aboutAmount" title="关联金额"></vxe-table-column>
        </vxe-table>
      </div>

      <div class="tip-211130">
        <h3 class="title">收付款信息</h3>
      </div>
      <div class="row-table-sty clearfix">
        <vxe-form :data="formData" title-colon ref="xForm1" title-width="150" title-align="right">
          <vxe-form-item title="所属公司" field="compName" span="8">
            <template>
              <Tooltip :content="formData.compName" placement="top" max-width="250">
                <span class="row-table-txt">{{ formData.compName }}</span>
              </Tooltip>
            </template>
          </vxe-form-item>
          <vxe-form-item title="客户名称" field="clientName" span="8">
            <template>
              <Tooltip :content="formData.clientName" placement="top" max-width="250">
                <span class="row-table-txt">{{ formData.clientName }}</span>
              </Tooltip>
            </template>
          </vxe-form-item>
          <vxe-form-item title="业务员" field="salesMan" span="8" v-if="isHavePermission('twoPayments:salesManRec')">
            <template>
              <Tooltip :content="formData.salesMan" placement="top" max-width="250">
                <span class="row-table-txt">{{ formData.salesMan }}</span>
              </Tooltip>
            </template>
          </vxe-form-item>
          <vxe-form-item title="日期" field="addTime" span="8" max-width="250">
            <template>
              <span class="row-table-txt">{{ formData.addTime }}</span>
            </template>
          </vxe-form-item>
          <vxe-form-item title="摘要" field="note" span="8">
            <template>
              <Tooltip :content="formData.note" placement="top" max-width="250">
                <span class="row-table-txt">{{ formData.note }}</span>
              </Tooltip>
            </template>
          </vxe-form-item>
          <vxe-form-item title="支付凭证流水号" field="payBankCode" span="8">
            <template>
              <Tooltip :content="formData.payBankCode" placement="top" max-width="250">
                <span class="row-table-txt">{{ formData.payBankCode }}</span>
              </Tooltip>
            </template>
          </vxe-form-item>
          <vxe-form-item title="总金额" field="payAmount" span="8">
            <template>
              <Tooltip :content="formData.payAmount" placement="top" max-width="250">
                <span class="row-table-txt">{{ formData.payAmount }}</span>
              </Tooltip>
            </template>
          </vxe-form-item>
          <vxe-form-item title="已关联金额" field="usedAmount" span="8">
            <template>
              <Tooltip :content="formData.usedAmount" placement="top" max-width="250">
                <span class="row-table-txt">{{ formData.usedAmount }}</span>
              </Tooltip>
            </template>
          </vxe-form-item>
          <vxe-form-item title="未关联金额" field="unusedAmount" span="8">
            <template>
              <Tooltip :content="formData.unusedAmount" placement="top" max-width="250">
                <span class="row-table-txt">{{ formData.unusedAmount }}</span>
              </Tooltip>
            </template>
          </vxe-form-item>
        </vxe-form>
        <vxe-form :data="formData" title-colon ref="xForm2" title-width="150" title-align="right">
          <vxe-form-item title="付款企业(人)名称" field="paymentsName" span="8">
            <template>
              <Tooltip :content="formData.paymentsName" placement="top" max-width="250">
                <span class="row-table-txt">{{ formData.paymentsName }}</span>
              </Tooltip>
            </template>
          </vxe-form-item>
          <vxe-form-item title="开户行" field="payBank" span="8">
            <template>
              <Tooltip :content="formData.payBank" placement="top" max-width="250">
                <span class="row-table-txt">{{ formData.payBank }}</span>
              </Tooltip>
            </template>
          </vxe-form-item>
          <vxe-form-item title="银行卡号" field="payAccount" span="8">
            <template>
              <Tooltip :content="formData.payAccount" placement="top" max-width="250">
                <span class="row-table-txt">{{ formData.payAccount }}</span>
              </Tooltip>
            </template>
          </vxe-form-item>
        </vxe-form>
        <vxe-form :data="formData" title-colon ref="xForm3" title-width="150" title-align="right">
          <vxe-form-item title="收款企业(人)名称" field="recName" span="8">
            <template>
              <Tooltip :content="formData.recName" placement="top" max-width="250">
                <span class="row-table-txt">{{ formData.recName }}</span>
              </Tooltip>
            </template>
          </vxe-form-item>
          <vxe-form-item title="开户行" field="recBank" span="8">
            <template>
              <Tooltip :content="formData.recBank" placement="top" max-width="250">
                <span class="row-table-txt">{{ formData.recBank }}</span>
              </Tooltip>
            </template>
          </vxe-form-item>
          <vxe-form-item title="银行卡号" field="recAccount" span="8">
            <template>
              <Tooltip :content="formData.recAccount" placement="top" max-width="250">
                <span class="row-table-txt">{{ formData.recAccount }}</span>
              </Tooltip>
            </template>
          </vxe-form-item>
        </vxe-form>
        <!-- <vxe-table
            border
            show-overflow
            keep-source
            ref="t2"
            class="table_insert"
            :auto-resize="true"
            :edit-rules="editRules"
            :data="tableData"
            :edit-config="{ trigger: 'click', mode: 'cell', showIcon: false }"
            @cell-click="cellClick"
        >
          <vxe-table-column
              field="compName"
              title="所属公司"
              align="center"
              style="height: 100%"
              :show-overflow="false"
          >
            <template v-slot="scope">
              <div>
                <div class="large-name">
                  <platform-corp
                      style="height: 100%"
                      v-if="isEdit"
                      :row="scope.row"
                      :field="'compName'"
                      :placeholder="'请选择平台企业'"
                      @select="$refs.t2.updateStatus(scope)"
                      @update="selectCompName"
                      :autoSave="false"
                  ></platform-corp>
                  <div class="large-name-text" v-else>
                    {{ scope.row.compName }}
                  </div>
                </div>
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="salesMan" title="业务员" align="center">
            <template v-slot="scope">
              <div>
                <sales-man
                    v-if="isEdit"
                    :row="scope.row"
                    :field="'salesMan'"
                ></sales-man>
                <div v-else>{{ scope.row.salesMan }}</div>
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column
              field="clientName"
              title="客户名称"
              align="center"
              :show-overflow="false"
          >
            <template v-slot="{ row }">
              <div>
                <div class="large-name">
                  <div
                      v-if="isEdit"
                      class="link-text"
                      @click="openChooseAccount(row, 'clientName')"
                  >
                    {{ row.clientName ? row.clientName : "选择客户" }}
                  </div>
                  <div class="large-name-text" v-else>{{ row.clientName }}</div>
                </div>
              </div>
            </template>
          </vxe-table-column>

          <vxe-table-column field="addTime" width="110" title="日期">
            <template v-slot="{ row }">
              <vxe-input
                  v-model="row.addTime"
                  placeholder="请选择"
                  type="date"
                  :editable="false"
                  transfer
                  v-if="isEdit"
              ></vxe-input>
              <div v-else>{{ row.addTime }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column
              field="note"
              title="摘要"
              width="80"
              :show-overflow="false"
          >
            <template v-slot="{ row }">
              <div>
                <vxe-input
                    v-model="row.note"
                    placeholder="必填"
                    v-if="isEdit"
                ></vxe-input>
                <div v-else>{{ row.note }}</div>
              </div>
            </template>
          </vxe-table-column>

          <vxe-table-column
              field="paymentsName"
              title="付款企业(人)名称"
              width="160"
              v-if="cate == 'SellerPayment'"
              :show-overflow="false"
          >
            <template v-slot="{ row }">
              <div>
                <div class="inner-column large-name">
                  <vxe-input
                      v-model="row.paymentsName"
                      placeholder="必填"
                      v-if="isEdit"
                  ></vxe-input>
                  <div class="large-name-text" v-else>
                    {{ row.paymentsName }}
                  </div>
                </div>
                <div class="inner-column-title">收款企业(人)名称</div>
                <div
                    class="inner-column link-text large-name"
                    @click="openBankAccountModal(row, 'recName', 'user')"
                >
                  <div class="large-name-text">
                    {{ row.recName }}
                  </div>
                </div>
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column
              field="paymentsName"
              title="付款企业(人)名称"
              width="160"
              v-else
              :show-overflow="false"
          >
            <template v-slot="{ row }">
              <div>
                <div class="inner-column large-name">
                  <vxe-input
                      v-model="row.paymentsName"
                      placeholder="必填"
                      v-if="isEdit"
                  ></vxe-input>
                  <div class="large-name-text" v-else>
                    {{ row.paymentsName }}
                  </div>
                </div>
                <div class="inner-column-title">收款企业(人)名称</div>
                <div
                    class="inner-column link-text"
                    @click="
                    openBankAccountModal(
                      row,
                      'recName',
                      cate == 'Collection' ? 'platform' : 'user'
                    )
                  "
                >
                  <div class="large-name-text">
                    {{ row.recName }}
                  </div>
                </div>
              </div>
            </template>
          </vxe-table-column>

          <vxe-table-column
              field="payBank"
              title="开户行"
              width="200"
              :show-overflow="false"
          >
            <template v-slot="{ row }">
              <div>
                <div class="inner-column large-name">
                  <div class="large-name-text">
                    {{ row.payBank }}
                  </div>
                </div>
                <div class="inner-column-title">开户行</div>
                <div class="inner-column large-name">
                  <div class="large-name-text">
                    {{ row.recBank }}
                  </div>
                </div>
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column
              field="payAccount"
              title="银行卡号"
              width="120"
              :show-overflow="false"
          >
            <template v-slot="{ row }">
              <div>
                <div class="inner-column large-name">
                  <div class="large-name-text">
                    {{ row.payAccount }}
                  </div>
                </div>
                <div class="inner-column-title">银行卡号</div>
                <div class="inner-column large-name">
                  <div class="large-name-text">
                    {{ row.recAccount }}
                  </div>
                </div>
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column
              field="payAmount"
              title="总金额"
              :show-overflow="false"
          >
            <template v-slot="{ row }">
              <vxe-input
                  v-model="row.payAmount"
                  @input="inputPayAmountEvent(row)"
                  placeholder="必填"
                  v-if="isEdit"
              ></vxe-input>
              <div v-else>{{ row.payAmount }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column
              field="usedAmount"
              title="已关联金额"
          ></vxe-table-column>
          <vxe-table-column
              :show-overflow="false"
              field="unusedAmount"
              title="未关联金额"
          ></vxe-table-column>
          <vxe-table-column
              field="payBankCode"
              title="支付凭证流水号"
              :show-overflow="false"
          >
            <template v-slot="{ row }">
              <vxe-input
                  v-model="row.payBankCode"
                  placeholder="选填"
                  v-if="isEdit"
              ></vxe-input>
              <div v-else>{{ row.payBankCode }}</div>
            </template>
          </vxe-table-column>
        </vxe-table>
        <vxe-table
            border
            show-overflow
            keep-source
            class="table_insert"
            ref="t3"
            :auto-resize="true"
            :data="tableData"
            :edit-rules="editRules"
            :edit-config="{ trigger: 'click', mode: 'cell', showIcon: false }"
            @cell-click="cellClick"
        ></vxe-table> -->
        <upload-table ref="uploadTable" v-if="tableData[0]" style="margin-top: 20px;" :row="tableData[0]"
                      :initFileList="tableData[0] && tableData[0].fileList ? tableData[0].fileList : []"
                      :isEdit="false"></upload-table>
        <!--        <div class="add-btn-box" v-if="row.isOnline === 0 && authUpdate()">-->
        <!--          <Button status="primary" @click="submitEvent" v-if="isEdit"-->
        <!--            >提交</Button-->
        <!--          >-->
        <!--        <Button status="primary" @click="editEvent" v-else>编辑</Button>&ndash;&gt;-->
        <!--        </div>-->
      </div>

      <!-- 弹窗 -->
      <!-- 选择关联订单 -->
      <vxe-modal
          v-model="isShowChooseOrder"
          width="1300"
          height="650"
          resize
          remember
          title="选择订单"
      >
        <choose-order
            :chainId="chainId"
            @choose="chooseOrderEvent"
            ref="refPaymentAboutOrder"
        ></choose-order>
      </vxe-modal>

      <!-- 选择企业 -->
      <vxe-modal
          v-model="isShowChooseAccount"
          width="800"
          height="600"
          resize
          remember
          title="选择客户"
      >
        <choose-account @choose="chooseAccountEvent" ref="chooseAccount"></choose-account>
      </vxe-modal>

      <!-- 选择银行账户 -->
      <vxe-modal
          v-model="isShowBankAccountModal"
          width="900"
          height="660"
          resize
          remember
          title="选择银行账户"
      >
        <bank-account
            @choose="chooseBankAccount"
            :isShow="isShowBankAccountModal"
            ref="bankAccountModal"
        ></bank-account>
      </vxe-modal>
    </div>
    <div class="clearfix" v-show="selectTab === 'tab2'">
      <div class="add-box clearfix" style="margin-bottom: 10px">
        <!-- :span-method="spanMethod" -->
        <vxe-table
            border
            show-footer
            show-overflow
            keep-source
            ref="orderList"
            align="center"
            auto-resize
            highlight-hover-row
            :data="aboutOrderList"
            @cell-click="cellClick"
            class="table-style"
            :footer-method="footerMethod"
            max-height="400"
        >
          <vxe-table-column field="ordersNum" title="订单编号">
            <template v-slot="{ row }">
              <div class="link-text">
                {{ row.ordersNum == "" || row.ordersNum == null ? "选择关联订单" : row.ordersNum }}
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="buyerName" title="托运人名称"></vxe-table-column>
          <vxe-table-column field="compName" title="平台企业"></vxe-table-column>
          <vxe-table-column field="sellerName" title="承运人名称"></vxe-table-column>
          <vxe-table-column field="aboutAmount" title="关联金额"></vxe-table-column>
        </vxe-table>
        <vxe-pager
            background
            size="small"
            :current-page.sync="page.currentPage"
            :page-size.sync="page.pageSize"
            :total="page.totalResult"
            @page-change="handlePageChange"
        ></vxe-pager>
      </div>
    </div>
  </div>
</template>

<script>
import $api from "@/apiProvider";
import UploadList from "@/components/common/UploadList";
import BankAccount from "@/components/modal/BankAccount";
import Account from "@/components/modal/Account";
import PlatformCorp from "@/components/common/PlatformCorp";
import CustomerSelect from "@/components/common/CustomerSelect";
import SalesMan from "@/components/common/SalesMan";
import getAuthOrization from "@/mixin/getAuthOrization";
import {orderDetail, showLoading, hideLoading, isNotEmpty} from "@/utils/util";
import {isEmpty} from "xe-utils/methods";
import AboutCollectionOrder from "@/components/order/AboutCollectionOrder";
import UploadTable from "@/components/modal/UploadTable";

const assign = (val) => Object.assign({}, val);
const empties = [undefined, "", null, "null", {}, [], "[]"];

export default {
  mixins: [getAuthOrization],
  name: "CollectionDetail",
  components: {
    ChooseOrder: AboutCollectionOrder,
    BankAccount,
    UploadTable,
    ChooseAccount: Account,
  },
  props: {
    cate: {
      type: String,
      default: "",
    },
    isShow: {
      type: Boolean,
      default: false,
    },
    chainId: [String, Number],
  },
  data() {
    return {
      queryAction: "",
      updateAction: "",

      paymentId: 0,

      isShowChooseOrder: false,
      amountListName: "",
      isShowChooseAccount: false,
      isShowBankAccountModal: false,

      isEdit: false,
      ordersList: [], //关联的订单数据
      aboutOrderList: [],
      orderTmp: {
        id: null,
        ordersId: null,
        aboutAmount: null,
        buyerName: null,
        chainNum: null,
        compName: null,
        ordersNum: null,
        sellerName: null,
        ordersVersion:null
      },
      row: {},
      tableData: [], //详情收付款数据 只有一条

      editRules: {
        payAmount: [
          {
            validator: this.requireValid,
          },
        ],
        salesMan: [
          {
            validator: this.requireValid,
          },
        ],
        addTime: [
          {
            validator: this.requireValid,
          },
        ],
        note: [
          {
            validator: this.requireValid,
          },
        ],
        paymentsName: [
          {
            validator: this.requireValid,
          },
        ],
        recName: [
          {
            validator: this.requireValid,
          },
        ],
      },
      selectTab: "tab1",
      usedAmount: null,
      page: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 0,
      },
      allAboutOrderList: [],
      formData: {
        compName: null,
        salesMan: null,
        clientName: null,
        addTime: null,
        note: null,
        payBankCode: null,
        payAmount: null,
        usedAmount: null,
        unusedAmount: null,
        paymentsName: null,
        payBank: null,
        payAccount: null,
        recName: null,
        recBank: null,
        recAccount: null,
      },
    };
  },
  watch: {
    isShow: {
      deep: true,
      immediate: true,
      handler: function (newVal, oldVal) {
        //关闭弹窗
        if (newVal == false && oldVal == true) {
          this.isEdit = false;
          this.selectTab = "tab1";
          this.aboutOrderList = [];
          this.page.totalResult = 0;
          this.page.pageSize = 10;
          this.page.currentPage = 1;
          this.usedAmount = null;
          // this.clearValidate();
        }
      },
    },
    cate: {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        switch (this.cate) {
          case "Collection":
            this.amountListName = "ordersBuyerAmountList";
            this.queryAction = "queryPaymentsRecDetail";
            this.updateAction = "updatePaymentsBuyer";
            break;
          case "Payment":
            this.amountListName = "ordersSellerAmountList";
            this.queryAction = "queryPaymentsPayDetail";
            this.updateAction = "updatePaymentsSeller";
            break;
        }
      },
    },
  },
  methods: {
    async init(paymentId, type) {
      this.paymentId = paymentId;
      this.getData(type);
    },
    checkTab(val) {
      this.selectTab = val;
    },
    setEdit(isEdit) {
      this.isEdit = isEdit;
    },
    async getData(type) {
      let res = await $api.twoPayments.request(this.queryAction, {
        id: this.paymentId,
      });
      if (res.status == 1) {
        let row = JSON.parse(JSON.stringify(res.data));
        // this.orderTmp.aboutAmount = row.payAmount
        // console.log(row, 'aaaaaaa');
        //详情数据从详情接口去取
        if (row.addTime != null) {
          row.addTime = this.$utils.toDateString(row.addTime, "yyyy-MM-dd");
        }
        if (row.createTime != null) {
          row.createTime = this.$utils.toDateString(row.createTime, "yyyy-MM-dd");
        }
        if (empties.includes(row.ordersList) || row.ordersList.length == 0) {
          this.ordersList = [assign(this.orderTmp)];
          this.aboutOrderList = [assign(this.orderTmp)];
        } else {
          this.ordersList = row.ordersList.filter((item) => item.id == this.paymentId);
          this.usedAmount = row.ordersList.reduce((prev, cur) => {
            return Math.round(cur.aboutAmount * 100) / 100 + prev;
          }, 0);
          this.usedAmount = Math.round(this.usedAmount * 100) / 100;
          this.page.totalResult = row.ordersList.length;
          this.allAboutOrderList = row.ordersList;
          this.aboutOrderList = row.ordersList.slice(0, this.page.pageSize);
          row[this.amountListName] = row.ordersList;
        }
        row.unusedAmount = parseFloat(row.unusedAmount).toFixed(2);
        // 不能根据this.ordersList.length 来判断
        if (this.ordersList.length > 0) {
          row.clientName = this.ordersList[0].clientName
              ? this.ordersList[0].clientName
              : res.data.clientName;
          row.salesMan = this.ordersList[0].salesMan
              ? this.ordersList[0].salesMan
              : res.data.salesMan;
        }
        // row.clientName =
        //   this.ordersList.length === 1
        //     ? this.ordersList[0].clientName
        //     : row.clientName;
        // row.salesMan =
        //     this.ordersList.length === 1
        //         ? this.ordersList[0].salesMan
        //         : row.salesMan;
        this.row = row;
        this.tableData = [row];
        this.formData = row;

        // console.log(this.tableData, 'rowwwww');
        // debugger
        if (isEmpty(row.fileList) && undefined != this.$refs.uploadTable) {
          this.$refs.uploadTable.init([]);
        }
      } else {
        if (empties.includes(res.message)) {
          res.message = "接口异常";
        }
        this.$XModal.message({
          status: "error",
          message: res.message,
        });
      }
    },
    handlePageChange({currentPage, pageSize}) {
      // 分页
      this.page.currentPage = currentPage;
      this.page.pageSize = pageSize;
      this.aboutOrderList = this.allAboutOrderList.slice(
          (currentPage - 1) * pageSize,
          currentPage * pageSize
      );
    },
    clearValidate() {
      this.$refs.t1.clearValidate();
      this.$refs.t2.clearValidate();
    },
    async requireValid(e) {
      if ([undefined, "", null, "null", {}, []].includes(e.cellValue)) {
        return Promise.reject(new Error(e.column.title + "必填"));
      }
    },
    inputPayAmountEvent(row) {
      if (!empties.includes(row.payAmount) && row.orderNum == " ") {
        row.orderNum = null;
      }
      this.$refs.t2.clearValidate();
    },
    async validEvent() {
      const errMap1 = await this.$refs.t1.validate().catch((errMap1) => errMap1);
      if (errMap1) return false;
      const errMap2 = await this.$refs.t2.validate().catch((errMap2) => errMap2);
      if (errMap2) return false;
      return true;
    },
    editEvent() {
      this.isEdit = true;
    },
    async cellClick(e) {
      let row = e.row;
      let field = e.column.property;
      let id = row.ordersId;
      if (this.isEdit) {
        if (field == "ordersNum") {
          this.openOrderModal();
        }
      } else {
        if (field == "ordersNum") {
          if (!this.isHavePermission("ordersTwo:detail")) {
            this.$Message["info"]({
              background: true,
              content: "对不起，您没有该权限！",
            });
            return;
          }
          let obj;
          if (row.ordersVersion === 2) {
            obj = {
              name: `订单详情2.0-${id}`,
              path: `/order2/orderdetail/${id}`,
            };
          } else if (row.ordersVersion === 4) {
            let obj = {};
            obj.name = `附属订单详情${id}`
            obj.path = `/subOrder/orderdetail/${id}`
            window.open(obj.path);
          } else {
            obj = {
              name: `撮合订单详情-${id}`,
              path: `/matching/orderdetail/${id}`,
            };
          }

          // let obj = {
          //   name: `订单详情2.0-${id}`,
          //   path: `/order2/orderdetail/${id}`
          // };
          window.open(obj.path);
          // this.$store.dispatch("tagsView/addVisitedView", obj);
          // this.$router.push(obj.path);
          return false;
        }
      }
    },
    footerMethod({columns, data}) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "单页合计";
          }
          if (["aboutAmount"].includes(column.property)) {
            return this.$utils.sum(data, column.property);
          }
          return null;
        }),
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "全部合计";
          }
          if (["aboutAmount"].includes(column.property)) {
            return this.usedAmount;
          }
          return null;
        }),
      ];
    },
    async selectCompName(row, id, name) {
      if (
          isNotEmpty(row.compName) &&
          row.compName != name &&
          isNotEmpty(row[this.amountListName])
      ) {
        let confirmRes = await this.$XModal.confirm("更换所属平台公司将清空关联订单", "是否更换");
        if (confirmRes === "confirm") {
          row[this.amountListName] = [];
          this.ordersList = [assign(this.orderTmp)];
        } else {
          return;
        }
      }
      row.platformCompanyId = id;
      row.compName = name;
    },
    openChooseAccount(row, field) {
      this.isShowChooseAccount = true;
      this.currentRow = row;
      this.currentChooseColumn = field;
      this.$refs.chooseAccount.init();
    },
    chooseAccountEvent(account, type) {
      console.log("chooseAccountEvent", account);
      this.currentRow[this.currentChooseColumn] = account.userName;
      this.isShowChooseAccount = false;
      this.$refs.t2.clearValidate(this.currentChooseColumn);
    },
    async openOrderModal() {
      if (!this.isEdit) return this.needEdit();
      //注意 点击关联订单的一行 实际要操作的数据却是 收付款的数据
      let row = this.tableData[0];
      if (empties.includes(row.payAmount)) {
        await this.$refs.t1.clearValidate();
        await this.$refs.t2.clearValidate();
        await this.$refs.t2.validate();
      } else {
        this.currentChooseColumn = this.amountListName;
        this.currentRow = row;
        this.isShowChooseOrder = true;
        this.$refs.refPaymentAboutOrder.init(
            this.cate,
            row.id,
            row.payAmount,
            this.ordersList,
            row.platformCompanyId
        );
      }
    },
    chooseOrderEvent(ordersList, usedAmount) {
      let oldOrderlist = this.currentRow[this.amountListName];
      var oldOrdersMap = {};
      //已经关联订单列表
      if (!empties.includes(oldOrderlist)) {
        oldOrderlist.forEach((item) => {
          oldOrdersMap[item.ordersId] = item.id;
        });
      }
      //新选择订单列表
      if (ordersList.length > 0) {
        ordersList.forEach((item) => {
          if (empties.includes(oldOrdersMap[item.id])) {
            item.id = null;
          } else {
            item.id = oldOrdersMap[item.id];
          }
          if (this.cate == "Collection") {
            item.compName = item.sellerName;
          } else if (this.cate == "Payment") {
            item.compName = item.buyerName;
          } else {
            //buyerName compName sellerName sellerLv2Name
            item.sellerLv2Name = item.sellerName;
            item.sellerName = item.buyerName;
            item.compName = "";
            item.buyerName = "";
          }
          //付款关联金额使用 付款信息的金额
          if (this.cate != "Collection") {
            item.aboutAmount = this.currentRow.payAmount;
            //所属公司-compName  业务员-salesMan  客户名称-clientName
            this.currentRow.platformCompanyId = item.platformCompanyId;
            this.currentRow.platformCompanyName = item.platformCompany;
            this.currentRow.salesMan = item.salesManName;
            this.currentRow.salesManId = item.salesMan;
            this.currentRow.clientName = item.sellerName;
          }
        });
      } else {
        ordersList = [assign(this.orderTmp)];
      }
      console.log(this.currentRow, ordersList[0]);

      this.currentRow[this.amountListName] = ordersList;
      this.currentRow.usedAmount = usedAmount;
      this.ordersList = ordersList;
      this.isShowChooseOrder = false;
      this.clearValidate();
    },
    openBankAccountModal(row, field, accountCate) {
      if (!this.isEdit) return this.needEdit();
      this.currentRow = row;
      this.currentChooseColumn = field;
      // console.log(field)
      this.isShowBankAccountModal = true;
      this.$refs.bankAccountModal.init(accountCate, field, row);
    },
    chooseBankAccount(bankAccount) {
      console.log("chooseBankAccount", this.currentChooseColumn, bankAccount);
      if (this.currentChooseColumn == "paymentsName") {
        this.currentRow.paymentsName = bankAccount.accountName;
        this.currentRow.payBank = bankAccount.bankName;
        this.currentRow.payAccount = bankAccount.accountNum;
      } else {
        this.currentRow.recName = bankAccount.accountName;
        this.currentRow.recBank = bankAccount.bankName;
        this.currentRow.recAccount = bankAccount.accountNum;
      }
      this.isShowBankAccountModal = false;
      this.$refs.t2.clearValidate(this.currentChooseColumn);
    },
    insertOrder() {
      if (!this.isEdit) return this.needEdit();
      this.$refs.t1.clearValidate();
      this.$refs.t1.insert(assign(this.orderTmp));
    },
    deleteOrder(row) {
      if (!this.isEdit) return this.needEdit();
      this.$refs.t1.remove(row);
    },

    async submitEvent() {
      let sts = await this.validEvent();
      if (!sts) {
        this.$XModal.message({
          status: "error",
          message: "校验不通过！",
        });
        return;
      }

      let row = assign(this.tableData[0]);

      row.addTime = this.$utils.timestamp(this.$utils.toStringDate(row.addTime));

      row.usedAmount = 0;
      if (this.ordersList.length == 1 && this.ordersList[0].ordersId == null) {
        row.ordersList = [];
      } else {
        row.ordersList = this.ordersList;
      }

      row.ordersList.forEach((order) => {
        row.usedAmount += order.aboutAmount;
      });
      row.unusedAmount = row.payAmount - row.usedAmount;
      row[this.amountListName] = row.ordersList;

      showLoading();
      let res = await $api.twoPayments.request(this.updateAction, row);
      hideLoading();

      if (res.status == 1) {
        this.$XModal.message("提交成功");
        this.$emit("close");
        this.$emit("init");
      } else {
        if (!res.message) {
          res.message = "接口异常";
        }
        this.$XModal.message(res.message);
      }
    },
    needEdit() {
      this.$XModal.message("编辑状态下才可操作");
    },
    spanMethod({rowIndex, columnIndex}) {
      if (columnIndex == 0) {
        if (rowIndex == 0) {
          return {
            rowspan: this.ordersList.length,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      } else {
        return {
          rowspan: 1,
          colspan: 1,
        };
      }
    },
    authUpdate() {
      return (
          (this.cate == "Collection" && this.isHavePermission("payments:updatePaymentsBuyer")) ||
          (this.cate == "Payment" && this.isHavePermission("payments:updatePaymentsSeller")) ||
          (this.cate == "SellerPayment" && this.isHavePermission("payments:updatePaymentsSellerLv2"))
      );
    },
  },
};
</script>
<style>
.detail-head {
  position: relative;
  height: 50px;
}

.detail-head .payment-tab-title {
  height: 50px;
  line-height: 50px;
  font-weight: normal;
}

.detail-head .payment-tab-title span {
  padding: 0 5px;
  cursor: pointer;
}

.detail-head .payment-tab-title span.on {
  font-weight: 700;
}

.detail-head .tip {
  position: absolute;
  right: 20px;
  top: 0;
  color: #606266;
  height: 50px;
  line-height: 50px;
  vertical-align: middle;
}

/* 详情 表格内样式 */
.link-text {
  color: #2d8cf0;
  font-size: 14px;
  font-family: Roboto;
  font-weight: 400;
}

.inner-column {
  height: 50px;
  overflow: hidden;
  vertical-align: middle;
  margin: auto;
  line-height: 50px;
}

.inner-column-title {
  background-image: linear-gradient(#f8f8f9, #f8f8f9), linear-gradient(#f8f8f9, #f8f8f9);
  color: #808695;
  background-repeat: no-repeat;
  border-top: 1px solid #e8eaec;
  border-bottom: 1px solid #e8eaec;
  line-height: 50px;
  height: 50px;
  overflow: hidden;
  vertical-align: middle;
}

.large-name {
  text-align: center;
  vertical-align: middle !important;
  position: relative;
  padding: 0;
  clear: both;
}

.large-name-text {
  margin: auto;
  display: inline-block;
  word-wrap: break-word !important;
  word-break: normal !important;
  vertical-align: middle !important;
  width: 100%;
  margin-left: -8px;
  line-height: 24px;
}
</style>
